import {oneOf} from 'shared/store';
import {observable, action, computed} from 'mobx';
import QUESTION_TYPES from './questionTypes';
import SECTION_TYPES from './sectionTypes';
import QAQuestion from '../questions/QAQuestion';
import _ from 'lodash';
class PerformanceReviewQuestion extends QAQuestion {
  @observable id;
  @observable name;
  @observable description;
  @observable lexicalState;
  @observable order;
  @observable required = true;
  @observable questionType;
  @observable args = {};

  @action merge(other) {
    super.merge(other, {
      questionType: oneOf(QUESTION_TYPES + SECTION_TYPES)
    });
  }

  @action updateText(value) {
    this.merge({name: value});
  }

  @computed get options() {
    return _.get(this.args, 'options');
  }

  @computed get questionName() {
    return this.name;
  }
}

export default PerformanceReviewQuestion;
